import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  const mainMn = [
    { name: t('header.nav.eelj'), href: "/eelj" },
    { name: t('header.nav.ebook'), href: "/ebook" },
    { name: t('header.nav.program'), href: "/program" },
    { name: t('header.nav.parent'), href: "/parent" },
    { name: t('header.nav.about'), href: "/about" },
  ];

  const mainEn = [
    { name: "About Us", href: "/about" },
    { name: "Camp Programs", href: "/camp-programs" },
    { name: "Events", href: "/events" },
    { name: "Services & Facilities", href: "/facilities" },
    { name: "News", href: "/news" },
    { name: "Contact", href: "/contact" },
  ];

  const navigation = {
    main: isEn ? mainEn : mainMn,
    social: [
      {
        name: "Facebook",
        href: "https://www.facebook.com/Nairamdalcamp",
        icon: (props: any) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        name: "Instagram",
        href: "https://www.instagram.com/nairamdal_mn/",
        icon: (props: any) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        name: "YouTube",
        href: "https://www.youtube.com/@nairamdal3168",
        icon: (props: any) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  };
  return (
    <footer className="relative bg-primary-800 text-white">
      {/* Top gradient line */}
      <div className="h-px bg-gradient-to-r from-transparent via-primary-500/50 to-transparent" />

      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-black mb-4">
              <span className="bg-gradient-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent">
                {t('footer.brand')}
              </span>
            </h3>
            <p className="text-slate-400 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500 mb-4">{t('footer.menu')}</h4>
            <nav className="space-y-3">
              {navigation.main.map((item) => (
                <a key={item.name} href={item.href}
                  className="block text-slate-400 hover:text-white transition-colors font-medium">
                  {item.name}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500 mb-4">{t('footer.contact')}</h4>
            <div className="space-y-3">
              {isEn && (
                <p className="text-sm text-slate-500 mb-2">International Programs: Ms. Mandakhzaya</p>
              )}
              <a href={isEn ? "tel:+97688095254" : "tel:+97675056010"} className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/5 border border-white/10">
                  <PhoneIcon className="h-5 w-5" />
                </div>
                <span className="font-medium">{isEn ? "+976 8809-5254" : "(+976) 7505-6010"}</span>
              </a>
              <a href={isEn ? "mailto:mandakhzaya@nairamdal.mn" : "mailto:icc@nairamdal.mn"} className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/5 border border-white/10">
                  <EnvelopeIcon className="h-5 w-5" />
                </div>
                <span className="font-medium">{isEn ? "mandakhzaya@nairamdal.mn" : "icc@nairamdal.mn"}</span>
              </a>
              {isEn && (
                <a href="mailto:icc@nairamdal.mn" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                  <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/5 border border-white/10">
                    <EnvelopeIcon className="h-5 w-5" />
                  </div>
                  <span className="font-medium">icc@nairamdal.mn</span>
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Social + Copyright */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            &copy; {new Date().getFullYear()} <span className="font-semibold text-slate-400">{t('footer.brand')}</span>. {t('footer.copyright')}
          </p>
          <div className="flex gap-3">
            {navigation.social.map((item) => (
              <a key={item.name} href={item.href} target="_blank" rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/5 border border-white/10 text-slate-400 hover:bg-white/10 hover:text-white transition-all duration-200">
                <item.icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
